var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-results-page"},[(_vm.$store.state.ui.device != 'mobile')?_c('Menu'):_vm._e(),(_vm.$store.getters.getUiFiltres)?_c('FiltresFiltres'):_vm._e(),(!_vm.$store.getters.getUiFiltres && _vm.$store.state.ui.device != 'mobile')?_c('Filters'):_vm._e(),_c('Content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }